<div class="admin-container container-fluid cxone-ui">
    <div class="row">
        <div class="col-12 d-flex justify-content-between">
            <div class="font-size-18 admin-title legacy-openSans-headline-h3" cvLocalizedText langSection="Admin" langKey="Admin_Page_Title">Admin
            </div>
        </div>
    </div>

    <div class="admin-tabs-container">
        <sol-tabs #adminTabs [selectedIndex]="0" size="extraLarge" (selectedTabChange)="onTabChanged($event)">
            <ng-container *ngFor="let tab of tabList">
                <ng-container [ngSwitch]="tab.name">
                    <ng-container *ngSwitchCase="tabType.GAMES">
                        <sol-tab [title]="tab.localizedName" [ariaLabel]="tabType.GAMES">
                            <cv-games-landing *ngIf="selectedTab === tabType.GAMES" [isCxone]="isCxone"></cv-games-landing>
                        </sol-tab>
                    </ng-container>
                    <ng-container *ngSwitchCase="tabType.CHALLENGES">
                        <sol-tab [title]="tab.localizedName" [ariaLabel]="tabType.CHALLENGES">
                            <cv-admin-challenge *ngIf="selectedTab === tabType.CHALLENGES"></cv-admin-challenge>
                        </sol-tab>
                    </ng-container>
                    <ng-container *ngSwitchCase="tabType.AWARDS">
                        <sol-tab [title]="tab.localizedName" [ariaLabel]="tabType.AWARDS">
                            <cv-awards-landing *ngIf="selectedTab === tabType.AWARDS" [isCxone]="isCxone" class="h-100 d-block overflow-auto"></cv-awards-landing>
                        </sol-tab>
                    </ng-container>
                    <ng-container *ngSwitchCase="tabType.BUDGET">
                        <sol-tab [title]="tab.localizedName" [ariaLabel]="tabType.BUDGET">
                            <cv-admin-budget class="h-100 d-block overflow-auto cxone-tab-landing" *ngIf="selectedTab === tabType.BUDGET"></cv-admin-budget>
                        </sol-tab>
                    </ng-container>
                </ng-container>
            </ng-container>
        </sol-tabs>
    </div>
</div>
